// extracted by mini-css-extract-plugin
module.exports = {"root":"az_Cbc","icon":"az_Dbc"};